// components/Hero.jsx

import React from "react";
import styles from "../styles/Hero.module.css";
import { useNavigate } from "react-router-dom";
import heroImage from "../assets/hero.jpg";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import welcomeAnimation from "../assets/welcome.lottie";

export default function Hero() {

  const navigate = useNavigate()

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className={styles.hero} style={{backgroundImage:`url(${heroImage}`}} id="home">
      
      {/* Dark Overlay */}
      <div className={styles.overlay}></div>

      {/* Content */}
      <div className={styles.content}>
        <span className={styles.subtitle}>
          seafood and corfiot tastes
        </span>

        <div>
          <DotLottieReact
          src={welcomeAnimation}
          autoplay
          loop
          className={styles.welcomeLottie}
        />
        </div>

      <h1>
        {'to'.split('').map((char, i) => (
          <span key={i} className={styles.letter}>
            {char === ' ' ? '\u00A0' : char}
          </span>
        ))}
        <br />
        {'Fegaropetra'.split('').map((char, i) => (
          <span key={i} className={styles.letter}>
            {char}
          </span>
        ))}
      </h1>

        <div className={styles.flipTextContainer}>
          Experience

          <div className={styles.flip}>
            <div><h2>Fresh Seafood</h2></div>
            <div><h2>Mediterranean Taste</h2></div>
            <div><h2>Coastal Dining</h2></div>
          </div>

          at Fegaropetra.
        </div>

        <div className={styles.buttons}>
          <button onClick={() => scrollToSection('menu')} className={styles.primaryBtn}>
            Explore Menu
          </button>

          <button onClick={() => navigate('/reservation')} className={styles.secondaryBtn}>
            Reserve Table
          </button>
        </div>
      </div>
    </section>
  );
}